

export default function serviceLinks () {
    const links = document.querySelectorAll('.services-list__link');
    if ( !links ) return;

    links
        .forEach(link => {
            const description = link.querySelector('.service-list__description');
            if ( !description ) return;

            link.addEventListener('mouseover', () => {
                description.showPopover({source: link});
            });

            link.addEventListener('mouseout', () => {
                description.hidePopover();
            });
        });
}
